<template>
    <div class='viewDetailWrap'>
        <!-- 상품 이미지 -->
        <div v-if='checkStringData(menu.imagePath)' class='thum'>
            <!-- <div class="gradation"></div> -->
            <img :src='menu.imagePath' @click='showOriginalImg'/>
        </div>
        <!-- 상품 정보 -->
        <div class='text'>
            <div class='tit'>
                <MenuName :menu='menu'>
                    <strong>{{menu.name}}</strong>
                </MenuName>
                <!-- 내 상품 추가/제거 -->
                <button v-if="appFlag && isUser && qrType == 1"
                    type='button'
                    class='btn like'
                    :class='{on: menu.myFavoriteMenuFlag}'
                    @click='MyMenu'/>
                <!-- <button v-else
                    type='button'
                    class='btn like'
                    :class='{on: menu.myFavoriteMenuFlag}'
                    @click='reqMyMenu'/> -->
            </div>
            <div class='txt'>{{menu.desc}}</div><!-- 상품 설명 -->
            <div class='txt' v-if="menu.discountFlag === 1 || menu.discountFlag === 2">{{$t('takeoutDiscountMsg',{ discountPrice : menu.discountPrice.toLocaleString()})}}</div><!-- 포장주문 설명 -->
            <div class='btm row'>
                <div class='col col1'>
                    <span class='price' :class='{disabled: !ableOrderFlag}'>
                        <em class='num'>{{formatComma(menu.price)}}</em>
                        <em class='won'>{{$t('MoneyUnit')}}</em>
                    </span>
                </div>
                <!-- 개수 조정 -->
                <div v-if='ableOrderFlag' class='col col2'>
                    <div class='intRange type2'>
                        <button
                            type='button'
                            class='btn minus'
                            :class='{disabled: count === 1}'
                            @click='subCount'>
                            minus
                        </button>
                        <input v-model='count' class='input' readonly/>
                        <button
                            type='button'
                            class='btn plus'
                            @click='addCount'>
                            plus
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- 상품 이미지 미리보기 component -->
<!--        <div v-if='showOriginalImgFlag' >-->
<!--          <LightBox :media='media'/>-->
<!--        </div>-->
      <AppModal
        v-show="modalToggle"
        :message="message"
        :btnCase="btnCase"
        @modalConfirm="modalConfirm"
      />
    </div>
</template>
<script lang="js">
import MenuName from '@/components/Common/MenuName.vue'
// import LightBox from 'vue-image-lightbox'
import { MENU_DETAIL_DATA } from '@/utils/EndPoint'
// import { REQ_MY_MENU } from '@/store/_actions/actionTypes'
// import { DEL_MY_MENU_CMD } from '@/utils/Api'
// import { NETWORK_ERROR_MESSAGE } from '@/utils/Message'
import Vue from 'vue'
import service from '@/backend/modnpay_app_api'

export default Vue.extend({
  name: MENU_DETAIL_DATA,
  props: ['menu', 'count', 'ableOrderFlag', 'userCode', 'storeGroupCode', 'storeCode'],
  components: { MenuName },
  data () {
    return {
      showOriginalImgFlag: false, // 이미지 미리보기 show flag
      media: [
        {
          thumb: this.menu.originalImagePath,
          src: this.menu.imagePath
        }
      ],
      type: 0,
      modalToggle: false,
      message: '',
      btnCase: 2
    }
  },
  computed: {
    qrType () { return this.$store.getters.qrType }
  },
  methods: {
    addCount () { // 개수 ++
      this.$emit('update:count', this.count + 1)
    },
    subCount () { // 개수 --
      if (this.count > 1) {
        this.$emit('update:count', this.count - 1)
      }
    },
    showOriginalImg () { // 상품 이미지 원본 미리보기
      this.showOriginalImgFlag = true
      this.showOriginalImgClickBtn() // extenstion
      this.setOriginalImgClickBtn(() => { this.showOriginalImgFlag = false }) // extenstion
    },
    // reqMyMenu () { // 관심상품 추가/제거
    //   const reqMyMenu = {
    //     cmd: DEL_MY_MENU_CMD,
    //     type: this.menu.myFavoriteMenuFlag + 2,
    //     menuCode: this.menu.code
    //   }
    //   this.$store.dispatch(REQ_MY_MENU, reqMyMenu)
    //     .then(() => {
    //       const changedFlag = this.menu.myFavoriteMenuFlag ^ 1
    //       this.$set(this.menu, 'myFavoriteMenuFlag', changedFlag)
    //       // 관심상품에 추가한 경우 Dialog 창 show
    //       if (changedFlag) {
    //         this.$emit('showAddMenuDialog')
    //       }
    //     })
    //     .catch(() => { this.toast(this, NETWORK_ERROR_MESSAGE) })
    // },
    async MyMenu () {
      const req = {
        type: this.menu.myFavoriteMenuFlag ? 3 : 2, // 1:리스트 2:추가 3:삭제
        menuCode: this.menu.code
      }
      const { data } = await service.myMenu(req)
      if (data.resultCode == 0) {
        this.menu.myFavoriteMenuFlag = !this.menu.myFavoriteMenuFlag
        if (this.menu.myFavoriteMenuFlag) {
          this.$emit('showAddMenuDialog')
        }
      } else if (data.resultCode == 20007) {
        this.openModal()
      }
    },
    openModal () {
      this.modalToggle = !this.modalToggle
      this.message = '관심상품에 담을 수 있는 최대수량 50개를 초과하였습니다. 상품을 삭제해주세요.'
      this.btnCase = 1
    },
    modalConfirm () {
      this.modalToggle = !this.modalToggle
    }
  }
})
</script>
